<p-toast [baseZIndex]="12000"></p-toast>
<div class="ui-g-12 bg" >
  <div class="ui-g-1 ui-md-2 ui-lg-3"></div>
  <div class="ui-g-12 ui-md-8 ui-lg-6 card">
    <div class="ui-g-12 ui-md-12 ui-lg-12 background">
      <div class="ui-g-12 p-text-left">
        <h2 class="title">¿Problemas de ingreso?</h2>
      </div>
    </div>
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <div class="ui-g-12 ui-fluid">
          <div *ngIf="selectedType == 0; then update"></div>
        </div>
        <div class="ui-g-12">
          <ng-template #update>
            <div class="cardGray3 ui-g-12 ui-md-12 ui-lg-12">
              <div class="ui-g-12">
                <h2 class="subTitle">Ingrese la siguiente información</h2>
              </div>
              <div class="ui-g-12">
                <div class="ui-g-12 form-group">
                  <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
                    <div class="ui-g-12">
                        <h4 class="subTitle2">Carnet o número de empleado</h4>
                        <input formControlName="id" id="float-input-id" type="text" size="80" minlength="3" maxlength="16" pInputText >
                        <p-message severity="error" text="carnet es requerido" *ngIf="!userform.controls['id'].valid&&userform.controls['id'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                        <h4 class="subTitle2">Nombre completo</h4>
                        <input formControlName="name" id="float-input-name" type="text" size="80" minlength="3" maxlength="60" pInputText >
                        <p-message severity="error" text="nombre completo es requerido" *ngIf="!userform.controls['name'].valid&&userform.controls['name'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                        <h4 class="subTitle2">Fecha de nacimiento</h4>
                        <!--<input formControlName="birthdate" id="float-input-birthdate" type="text" size="80"  pInputText >-->
                        <p-calendar formControlName="birthdate"  id="float-input-birthdate"  dateFormat="dd/mm/yy" placeholder="Fecha de nacimiento" yearNavigator="true" [yearRange]="yearRange" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
                        <p-message severity="error" text="fecha de nacimiento es requerido" *ngIf="!userform.controls['birthdate'].valid&&userform.controls['birthdate'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Correo electrónico</h4>
                      <input formControlName="email" id="float-input-email" type="email" size="40" minlength="6"  pInputText ngModel email>
                      <p-message severity="error" text="correo electrónico es requerido" *ngIf="!userform.controls['email'].valid&&userform.controls['email'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12">
                        <h4 class="subTitle2">Número de teléfono</h4>
                      </div>
                      <div class="ui-g-6 ui-md-6 ui-sm-12">
                          <p-dropdown [options]="items"  formControlName="country"  placeholder="{{countryTitle}}" optionLabel="idCode" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown>
                          <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
                      </div>
                      <div class="ui-g-6 ui-md-6 ui-sm-12">
                          <input id="float-input" type="text" (keypress)='validate($event)'  pInputText formControlName="phoneNumber" minlength="4" maxlength="12">
                          <p-message severity="error" text="número de teléfono es requerido" *ngIf="!userform.controls['phoneNumber'].valid&&userform.controls['phoneNumber'].dirty"></p-message>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Documento de identificación</h4>
                      <input id="float-input-dpi" type="text" (keypress)='validate($event)' size="30"  pInputText formControlName="dpi" minlength="6" maxlength="20">
                      <p-message severity="error" text="dpi es requerido" *ngIf="!userform.controls['dpi'].valid&&userform.controls['dpi'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Adjuntar imágenes</h4>
                       <p-fileUpload 
                         #fileUpload
                         name="myfile[]" 
                         [customUpload]="true" 
                         multiple="true"
                         [auto]="true"
                         (uploadHandler)="myUploader($event)"
                         chooseLabel="Seleccionar imágenes"
                         uploadLabel="Carga"
                         cancelLabel="Cancela"
                         (change)="onChange($event)"
                         class="ui-button-primary ui-button-rounded" >
                       </p-fileUpload>
                     </div>
                    <div class="ui-g-12">
                      <button class="ui-button ui-fluid btn" pButton type="submit" label="{{loginBtnTitle}}" [disabled]="!userform.valid" ></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ng-template>
          <div class="progress-spinner" *ngIf="env.isContentLoading">
            <img src="assets/images/Logo-1.gif" alt="" width="300px">
          </div>
        </div>
      </div>
  </div>
  <div class="ui-g-1 ui-md-2 ui-lg-3"></div>
   
  </div>
  
  